import { Nav } from "@/components/fronk/Nav";
import { Hero } from "@/components/fronk/Hero";
import { TickerMarquee } from "@/components/fronk/TickerMarquee";
import { ChairmanMemo } from "@/components/fronk/ChairmanMemo";
import { FeePipeline } from "@/components/fronk/FeePipeline";
import { StaffGrid } from "@/components/fronk/StaffGrid";
import { NightShift } from "@/components/fronk/NightShift";
import { Onboarding } from "@/components/fronk/Onboarding";
import { Footer } from "@/components/fronk/Footer";
import { CoinTrail } from "@/components/fronk/CoinTrail";

export default function FronkPage() {
  return (
    <div className="min-h-screen bg-[color:var(--paper-0)]">
      <CoinTrail />
      <Nav />
      <main>
        <Hero />
        <TickerMarquee />
        <ChairmanMemo />
        <FeePipeline />
        <TickerMarquee dark />
        <StaffGrid />
        <NightShift />
        <Onboarding />
      </main>
      <Footer />
    </div>
  );
}
